import { useState } from "react";
import { Box, Checkbox, InputAdornment, styled, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { CheckBoxFormControlLabel } from "../../TableStyles";
import { useTranslation } from "react-i18next";
import { normalizeKey } from "../../../../../Helper/Common/common_helpers";

const StyledSearchInput = styled(TextField)(({ theme }) => ({
    width: "100%",
    "& .MuiOutlinedInput-root": {
        borderRadius: "12px",
        paddingLeft: "0px",
    },
    "& fieldset": {
        border: "none !important",
    },
    "&:hover fieldset": {
        border: "none !important",
    },
    "&.Mui-focused fieldset": {
        border: "none !important",
    },
    "& .MuiInputBase-input": {
        padding: 0,
        fontSize: "12px !important",
        fontWeight: 400,
        border: "none !important",
        caretColor: "#5D5D5D",
        "&::placeholder": {
            fontSize: "12px",
            color: "#ADB5BE",
            opacity: 1,
        },
    },
}));

const MultiSelectFilter = ({ filter, newFilters, onChange }) => {
    const { t } = useTranslation(['common', 'generic_table', 'filters']);
    const [searchTerm, setSearchTerm] = useState("");
    const filterValues = filter.values;
    const searchThreshold = 5

    const filteredValues = filterValues.filter((filterValue) =>
        filterValue.value.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const renderSearchInput = () => {
        return (
            <Box sx={{
                width: "100%",
                mb: 1,
                py: 0.5,
                paddingRight: '0px',
                border: "1px solid #EBEFF3",
                borderRadius: "12px"
            }}>
                <StyledSearchInput
                    placeholder={` ${t('search_placeholder')} ${filter.label}`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start" sx={{ marginRight: '4px', marginLeft: '8px' }}>
                                    <SearchIcon sx={{ color: "#808080", fontSize: '18px', p: 0 }} />
                                </InputAdornment>
                            ),
                        }
                    }}
                />
            </Box>
        )
    }

    return (
        <Box>
            {filterValues.length > searchThreshold && renderSearchInput()}

            <Box sx={{ height: '160px', overflow: 'auto', width: '100%' }}>
                {filteredValues.filter((v) => v.value).map((filterValue, index) => (
                    <CheckBoxFormControlLabel
                        key={index}
                        control={
                            <Checkbox
                                sx={{ color: '#9F9F9F' }}
                                checked={newFilters?.[filter?.key]?.includes(filterValue.id) || false}
                                onChange={onChange(filter.key, filterValue.id)}
                            />
                        }
                        label={t(`filters:${normalizeKey(filterValue.value)}`, filterValue.value)}
                    />
                ))}
            </Box>
        </Box>
    );
};


export default MultiSelectFilter;